import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/ic";
import { ICService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";

function* getData({ value }) {
  try {
    const { data } = yield call(() => ICService.getData());
    if (data) {
      yield put({
        type: types.IC_DATA_SUCCESS,
        value: { data: data.data, options: data.options },
      });
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.IC_DATA_FAILED,
      value: formattedErrors,
    });
  }
}

export default function* init() {
  yield takeEvery(
    types.IC_DATA,
    getData,
  );
}
